export default {"src":"/_next/static/media/cyclist.mono.fc8bb639.svg","height":364,"width":364,"blurWidth":0,"blurHeight":0};